import XLSX from "xlsx";

export const downloadExel = (nameTable, selector) => {
  let table = document.querySelector(selector);
  let cloneTable = table.cloneNode(true);
  let wb = XLSX.utils.table_to_book(cloneTable, { raw: true });
  XLSX.writeFile(wb, `${nameTable}.xlsx`);
};
